export const FEATURE_FLAG_KEYS = {
    enableInspect: 'enable_inspect',
    enableNewOzowRedirect: "enable_ozow_redirect"
}

export const redirectUrl = "https://dev.d1g5rtdsk1pe2f.amplifyapp.com"

export const mobileMoneyInstructionMap: Record<string, string> = {
    GHS: "Please follow the instructions sent to your mobile money app to complete the payment.",
    XAF: "Please follow the instructions sent to your mobile money app to complete the payment."
}